import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getHeader} from "../../../_fri/utils/function";
import {
    CancelPaymentRequest,
    CancelPaymentResponse, CheckPaymentStatusRequest, CheckPaymentStatusResponse,
    SearchUserRequest,
    SearchUserResponse,
    SendPaymentRequest,
    SendPaymentResponse
} from "../interface/ecommerce";

export const ecommerce = createApi({

        reducerPath: "ecommerce",
        baseQuery: fetchBaseQuery({
            baseUrl: `${process.env.REACT_APP_API_URL}/business/`,
            prepareHeaders: (headers, {getState}) => {
                return getHeader(headers, getState);
            },
        }),
        endpoints: (builder) => ({
            searchFriUser: builder.mutation<SearchUserResponse, SearchUserRequest>({
                query: (data) => ({
                    url: `processors/v1/persons/search`,
                    method: "Post",
                    body: data,
                }),
            }),
            sendPayment: builder.mutation<SendPaymentResponse, SendPaymentRequest>({
                query: (data) => ({
                    url: `transactions/v1/requests/send`,
                    method: "Post",
                    body: data,
                }),
            }),
            cancelPayment: builder.mutation<CancelPaymentResponse, CancelPaymentRequest>({
                query: (data) => ({
                    url: `transactions/v1/requests/cancel`,
                    method: "Post",
                    body: data,
                }),
            }),
            checkTransactionStatus: builder.mutation<CheckPaymentStatusResponse, CheckPaymentStatusRequest>({
                query: (data) => ({
                    url: `processors/v1/transactions/retrieve`,
                    method: "Post",
                    body: data,
                }),
            }),

        }),
    })
;

export const {useSearchFriUserMutation, useSendPaymentMutation, useCancelPaymentMutation, useCheckTransactionStatusMutation}=ecommerce